import { buildCrudRoutes, baseRoute, makeMetaRoute } from '@/app/arch/components/crud/CrudRouter';
import moduleBreadcrumbs from '../../moduleBreadcrumbs';

function sameBaseProps({
  text,
  disabled,
  to,
}) {
  return {
    moduleActive: 'contacard',
    subModuleActive: 'communication',
    moduleGroupName: 'notification',
    baseBreadcrumbs: [
      ...moduleBreadcrumbs,
      {
        text,
        to,
        disabled,
      },
    ],
  };
}

const {
  baseBreadcrumbs: breadcrumbs,
  moduleActive,
  moduleGroupName: groupName,
  subModuleActive,
} = sameBaseProps({
  disabled: true,
  text: 'Criar notificação',
});

const NewNotification = baseRoute({
  component: () => import('Modules/contacard/communication/notifications/NotificationsForm.vue'),
  name: 'notifications.new',
  path: 'notification/new',
  meta: makeMetaRoute({
    card: {
      title: 'Criar notificação',
      icon: 'message-plus',
    },
    breadcrumbs,
    groupName,
    moduleActive,
    subModuleActive,
  }),
});

const EditNotification = {
  editRoute: {
    component: () => import('Modules/contacard/communication/notifications/NotificationsForm.vue'),
    breadcrumbs: [
      {
        text: 'Visualizar detalhes',
        disabled: true,
      },
    ],
  },
};

const searchOptions = {
  searchComponent: () => import('Arch/components/crud/components/OnlySearchFilter.vue'),
  searchOptions: { label: 'Buscar notificação', searchAttribute: 'search' },
};

const DraftNotification = buildCrudRoutes({
  baseName: 'draftNotification',
  basePath: 'notification-draft',
  card: {
    title: 'Rascunho de notificações',
    icon: 'message-draw',
  },
  listRoute: {
    pageContent: () => import('Modules/contacard/communication/notifications/DraftNotificationsList.vue'),
    speedFilter: () => import('@/app/modules/contacard/communication/notifications/components/filters/NotificationSpeedFilter.vue'),
    ...searchOptions,
    pageTitle: 'Rascunho de notificações',
    navigateBackRoute: 'contacard.submodules.list',
  },
  ...EditNotification,
  ...sameBaseProps({
    text: 'rascunho de notificações',
    disabled: false,
    to: 'draftNotification.list',
  }),
});

const HistoryNotification = buildCrudRoutes({
  baseName: 'historyNotification',
  basePath: 'history-notification',
  card: {
    title: 'Histórico de notificações',
    icon: 'cellphone-message',
  },
  listRoute: {
    pageContent: () => import('Modules/contacard/communication/notifications/NotificationsCrudList.vue'),
    speedFilter: () => import('@/app/modules/contacard/communication/notifications/components/filters/NotificationSpeedFilter.vue'),
    ...searchOptions,
    pageTitle: 'Histórico de notificações',
    navigateBackRoute: 'contacard.submodules.list',
  },
  ...EditNotification,
  ...sameBaseProps({
    text: 'histórico de notificações',
    disabled: false,
    to: 'historyNotification.list',
  }),
});

export default [
  NewNotification,
  ...DraftNotification,
  ...HistoryNotification,
];
